<script>
  import { createEventDispatcher } from 'svelte';
  import Modal from '@components/Modal.svelte';
  import ProgressBar from '@components/ProgressBar.svelte';
  import StartTrendingFirstStep from '../post-onboarding/StartTrendingFirstStep.svelte';
  import StartTrendingSecondStep from '../post-onboarding/StartTrendingSecondStep.svelte';
  import StartTrendingThirdStep from '../post-onboarding/StartTrendingThirdStep.svelte';
  import StartTrendingFourthStep from '../post-onboarding/StartTrendingFourthStep.svelte';
  import StartTrendingFifthStep from '../post-onboarding/StartTrendingFifthStep.svelte';
  import StartTrendingSixthStep from '../post-onboarding/StartTrendingSixthStep.svelte';
  import jQuery from 'jquery';
  import Track from '@utils/track';
  import Cookie from 'js-cookie';
  const stepsMap = { first: 1, second: 2, third: 3, fourth: 4, fifth: 5, sixth: 6 };
  const stepsTitle = {
    first: 'WANT BENABLE TO GROW YOUR REACH?',
    second: 'KEEP ADDING RECS',
    third: 'HOW WILL YOU KNOW WHEN THE ALGORITHM LOVES YOUR LIST?',
    fourth: 'WHEN YOUR LIST IS OPTIMIZED, IT’S PUSHED OUT EVERYWHERE!',
    fifth: 'WITH A FEW OPTIMIZED LISTS, YOUR PROFILE WILL TREND TOO',
    sixth: 'THAT’S IT! NOW GET YOUR FIRST OPTIMIZED LIST',
  };

  const dispatch = createEventDispatcher();

  export let showModal = false;
  export let mobile = false;
  export let currentUser = null;
  let currentStep = 'first';

  const progressMultiplier = 100 / 6.0;
  let progressValue = progressMultiplier;
  let showHideStep = function (previousStep) {
    jQuery(`.start-trending-step-${previousStep}`).hide();
    jQuery(`.start-trending-step-${currentStep}`).fadeIn('slow');
  };
  let handleNextClick = async function () {
    const previousStep = currentStep;
    if (currentStep == 'first') {
      currentStep = 'second';
      progressValue = progressMultiplier * 2;
    } else if (currentStep == 'second') {
      currentStep = 'third';
      progressValue = progressMultiplier * 3;
    } else if (currentStep == 'third') {
      currentStep = 'fourth';
      progressValue = progressMultiplier * 4;
    } else if (currentStep == 'fourth') {
      currentStep = 'fifth';
      progressValue = progressMultiplier * 5;
    } else if (currentStep == 'fifth') {
      currentStep = 'sixth';
      progressValue = 100;
    } else {
      showModal = false;
    }
    if (previousStep == 'sixth') {
      Cookie.set('start-trending-done', 'true');
      dispatch('completed');
      Track.listTrendingDoneClick({
        currentUser: currentUser,
        stepNumber: stepsMap[previousStep],
        totalSteps: 6,
        title: stepsTitle[previousStep],
      });
    } else {
      Track.listTrendingNextClick({
        currentUser: currentUser,
        stepNumber: stepsMap[previousStep],
        totalSteps: 6,
        title: stepsTitle[previousStep],
      });
    }
    showHideStep(previousStep);
  };
  let handleHowToEarnClick = async function () {
    Track.howEarnOptimizedBadgeClick({ currentUser: currentUser });
    window.open('/list-optimization-tips', '_blank').focus();
  };
  let handleCloseButtonClick = function () {
    showModal = false;
  };
  let handleBackButtonClick = async function () {
    let previousStep = currentStep;
    if (currentStep == 'first') {
      progressValue = progressMultiplier;
    } else if (currentStep == 'second') {
      currentStep = 'first';
      progressValue = progressMultiplier;
    } else if (currentStep == 'third') {
      currentStep = 'second';
      progressValue = progressMultiplier * 2;
    } else if (currentStep == 'fourth') {
      currentStep = 'third';
      progressValue = progressMultiplier * 3;
    } else if (currentStep == 'fifth') {
      currentStep = 'fourth';
      progressValue = progressMultiplier * 4;
    } else {
      currentStep = 'fifth';
      progressValue = progressMultiplier * 5;
    }
    Track.listTrendingBackClick({ currentUser: currentUser, stepNumber: stepsMap[previousStep], totalSteps: 6 });
    showHideStep(previousStep);
  };
</script>

<style style="text/scss" lang="scss">
  @import '../../vendor/design-system.scss';
  .next-button {
    display: flex;
    width: 411px;
    height: 48px;
    padding: 14px 24px;
    justify-content: center;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
    border-radius: 12px;
    background: #7a5cfa;
    color: #fff;
    text-align: center;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    cursor: pointer;
    margin-top: 30px;
    z-index: 1;
    &.mobile {
      width: 80%;
    }
  }
  .list-steps-button {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    cursor: pointer;
    z-index: 1;
    color: #7a5cfa;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px; /* 150% */
    margin-top: 24px;
  }

  * :global(.modal__container) {
    padding: 0px !important;
  }

  .back-button {
    position: absolute;
    top: 17px;
    left: 23px;
    cursor: pointer;
  }
  .close-button {
    position: absolute;
    top: 17px;
    right: 24px;
    cursor: pointer;
  }

  .progress-bar-container {
    position: absolute;
    width: 100%;
    top: 53px;
  }

  * :global(.creator-spotlight-modal__container-desktop) {
    max-width: 640px !important;
  }
  * :global(.creator-spotlight-modal__container-mobile) {
    width: calc(100% - 20px) !important;
  }
</style>

<div class="svelte-modal svelte-creator-spotlight-modal">
  <Modal
    on:close={() => {
      dispatch('close');
    }}
    show={showModal}
    showCloseButton={false}
    fadeInDuration={0}
    closeOnOverlayClick={false}
    containerClass="creator-spotlight-modal__container-{mobile ? 'mobile' : 'desktop'}">
    <div slot="header" style="position: relative;">
      <div
        on:click|preventDefault|stopPropagation={handleBackButtonClick}
        class="back-button {currentStep == 'first' ? 'hidden' : ''}">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path
            d="M6.3584 8.7666C5.67999 9.44922 5.6798 10.5519 6.3584 11.2344L13.0869 18.001L13.6182 17.4717L14.1504 16.9424L7.42285 10.1768C7.32589 10.0792 7.32589 9.92173 7.42285 9.82422L14.1504 3.05762L13.6182 2.52832L13.0869 2L6.3584 8.7666Z"
            fill="#B3B3B3" />
        </svg>
      </div>

      <div on:click|preventDefault|stopPropagation={handleCloseButtonClick} class="close-button">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path
            d="M16.9883 4.06171L11.0498 9.99921L16.9883 15.9377L16.458 16.468L15.9277 16.9992L9.98926 11.0607L4.05078 16.9992L3.52051 16.468L2.99023 15.9377L8.92773 9.99921L2.99023 4.06171L4.05078 3.00116L9.98926 8.93866L15.9277 3.00116L16.9883 4.06171Z"
            fill="#B3B3B3" />
        </svg>
      </div>
      <div class="progress-bar-container"><ProgressBar value={progressValue} /></div>
    </div>
    <div
      slot="content"
      style="text-align: center; margin-top: 24px; display: flex; flex-direction: column; align-items: center; min-height: 500px; margin-top: 88px; {mobile
        ? ' padding-left: 10px !important; padding-right: 10px !important;'
        : ''}">
      <StartTrendingFirstStep mobile={mobile} />
      <StartTrendingSecondStep mobile={mobile} />
      <StartTrendingThirdStep mobile={mobile} />
      <StartTrendingFourthStep mobile={mobile} />
      <StartTrendingFifthStep mobile={mobile} />
      <StartTrendingSixthStep mobile={mobile} />
      <div
        class="next-button {mobile ? 'mobile' : 'desktop'}"
        on:click|preventDefault|stopPropagation={handleNextClick}>
        {currentStep == 'sixth' ? 'Done' : 'Next'}
      </div>

      {#if currentStep == 'sixth'}
        <div on:click|preventDefault|stopPropagation={handleHowToEarnClick} class="list-steps-button">
          How to earn the Optimized Badge
        </div>
      {/if}
    </div>
  </Modal>
</div>
